import type { GridBaseProps } from "@repo/ui";

import { faTimes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { SortTypeEnum } from "@repo/models";
import { Button, ButtonColor, ButtonSize, Column, GridPreLoaded, OriginalTimezoneDateColumn } from "@repo/ui";
import { useMemo, useState } from "react";

import type { MVCStateSpecificTraining } from "../../../../models/MVCStateSpecificTraining";

import { useTrainingApi, useTrainingQueries } from "../../../../api/trainingApi";
import { DeleteAlertDialog } from "../../../../components/deleteAlertDialog";
import style from "./style.module.scss";

export default function StateSpecificTrainingGridBasic(props: GridBaseProps<MVCStateSpecificTraining>) {
	const { useStateSpecificTrainingsQuery } = useTrainingQueries();
	const { deleteStateSpecificTraining } = useTrainingApi();
	const { data, loaded, clearQuery } = useStateSpecificTrainingsQuery();

	const [deleteTrainingId, setDeleteTrainingId] = useState<number | null>(null);

	const columns = useMemo(
		() =>
			[
				new Column("", "id").withFormat(renderDeleteButton),
				new OriginalTimezoneDateColumn("Training Date", "trainingDate")
					.dateOnly()
					.withSortBy(SortTypeEnum.ascending),
				new Column("Trainer Name", "trainerName"),
				new Column("State", "stateName"),
				new Column("Commodity Type", "commodityType"),
				new Column("Passed?", "passFail").withBooleanFormat(),
			] as Column<MVCStateSpecificTraining>[],
		[],
	);

	function deleteButtonClick(id: number) {
		setDeleteTrainingId(id);
	}

	async function confirmDelete() {
		if (deleteTrainingId) {
			await deleteStateSpecificTraining(deleteTrainingId);
			await clearQuery();
			setDeleteTrainingId(null);
		}
	}

	function renderDeleteButton(customerActionId: number) {
		return (
			<div className={style.editButtons}>
				<Button
					color={ButtonColor.Green}
					onClick={() => deleteButtonClick(customerActionId)}
					size={ButtonSize.medium}
				>
					<FontAwesomeIcon icon={faTimes} size="lg" />
					Delete
				</Button>
			</div>
		);
	}

	return (
		<>
			<GridPreLoaded
				title={null}
				id="stateSpecificTrainingGrid"
				pageSize={3}
				columns={columns}
				values={data?.data ?? []}
				loading={!loaded}
				getData={clearQuery}
				{...props}
			/>
			<DeleteAlertDialog
				isOpen={!!deleteTrainingId}
				onClose={() => setDeleteTrainingId(null)}
				onConfirm={confirmDelete}
				title="Delete Training"
				description="Are you sure you want to delete this training?"
			/>
		</>
	);
}
